(function () {
  'use strict';

  function money(cents, currency) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: currency || 'EUR',
    }).format((Number(cents) || 0) / 100);
  }

  function setHidden(element, hidden) {
    if (!element) return;
    element.hidden = Boolean(hidden);
  }

  function initGallery(root) {
    var main = root.querySelector('.vp-socle__main-image');
    if (!main) return;
    root.querySelectorAll('[data-vp-socle-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-image-url');
        if (!url) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = url;
        main.alt = button.getAttribute('data-image-alt') || '';
        root.querySelectorAll('[data-vp-socle-thumb]').forEach(function (item) {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
      });
    });
  }

  function initVariants(root) {
    var variantsNode = root.querySelector('[data-vp-socle-variants]');
    var form = root.querySelector('[data-vp-product-form]');
    if (!variantsNode || !form) return;
    var variants;
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    var selects = Array.from(root.querySelectorAll('[data-vp-socle-option]'));
    var idInput = form.querySelector('[name="id"]');
    var quantity = form.querySelector('[name="quantity"]');
    var atc = form.querySelector('[data-vp-socle-atc]');
    var stickyAtc = root.querySelector('[data-vp-socle-sticky-button]');
    var price = root.querySelector('[data-vp-socle-price]');
    var stickyPrice = root.querySelector('[data-vp-socle-sticky-price]');
    var compare = root.querySelector('[data-vp-socle-compare]');
    var stock = root.querySelector('[data-vp-socle-stock]');
    var currency = root.getAttribute('data-currency') || 'EUR';
    var mainImage = root.querySelector('.vp-socle__main-image');

    function currentVariant() {
      if (!selects.length) return variants[0];
      var choices = selects.map(function (select) { return select.value; });
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return String(option) === String(choices[index]);
        });
      });
    }

    function render(updateFeaturedImage) {
      var variant = currentVariant();
      var available = Boolean(variant && variant.available);
      if (idInput) idInput.value = variant ? variant.id : '';
      if (price) price.textContent = variant ? money(variant.price, currency) : '';
      if (stickyPrice) stickyPrice.textContent = variant ? money(variant.price, currency) : '';
      if (compare) {
        var showCompare = Boolean(variant && variant.compare_at_price > variant.price);
        compare.textContent = showCompare ? money(variant.compare_at_price, currency) : '';
        setHidden(compare, !showCompare);
      }
      if (quantity) {
        var max = variant && Number.isFinite(Number(variant.inventory_quantity))
          ? Math.max(1, Math.min(99, Number(variant.inventory_quantity)))
          : 99;
        quantity.max = String(max);
        if (Number(quantity.value) > max) quantity.value = String(max);
      }
      if (stock) {
        if (!variant) {
          stock.textContent = 'Variante indisponible';
        } else if (!available) {
          stock.textContent = 'Temporairement indisponible';
        } else if (Number(variant.inventory_quantity) > 0 && Number(variant.inventory_quantity) <= 10) {
          stock.textContent = 'Stock suivi : ' + variant.inventory_quantity + ' unité'
            + (Number(variant.inventory_quantity) > 1 ? 's disponibles' : ' disponible');
        } else {
          stock.textContent = 'En stock';
        }
      }
      [atc, stickyAtc].forEach(function (button) {
        if (!button) return;
        button.disabled = !available;
        button.textContent = available ? 'Ajouter au panier' : 'Indisponible';
      });
      if (updateFeaturedImage && variant && variant.featured_image && mainImage) {
        var featuredUrl = new URL(variant.featured_image.src, window.location.origin);
        featuredUrl.searchParams.set('width', '1200');
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = featuredUrl.toString();
        mainImage.alt = variant.featured_image.alt || mainImage.alt;
      }
      if (variant && window.history && window.history.replaceState) {
        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', nextUrl.toString());
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () { render(true); });
    });
    render(false);
  }

  function initSticky(root) {
    var primary = root.querySelector('[data-vp-socle-atc]');
    var sticky = root.querySelector('[data-vp-socle-sticky]');
    if (!primary || !sticky || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > primary.offsetTop);
      });
    }, { threshold: 0 });
    observer.observe(primary);
  }

  function init(root) {
    initGallery(root);
    initVariants(root);
    initSticky(root);
  }

  document.querySelectorAll('[data-vp-product-socle]').forEach(init);
}());
